import type { SuperadminInvoiceStatus } from '../types';

/* ===============================
   Invoice Status Definitions
================================ */

export const SUPERADMIN_INVOICE_STATUSES: Record<
  SuperadminInvoiceStatus,
  SuperadminInvoiceStatus
> = {
  PAID: 'PAID',
  INITIATED: 'INITIATED',
  HOLD: 'HOLD',
  REJECTED: 'REJECTED',
};

/* ===============================
   Status Groups
================================ */

export const SUPERADMIN_STATUS_GROUPS: Record<
  'SUCCESSFUL' | 'PENDING' | 'FAILED',
  SuperadminInvoiceStatus[]
> = {
  SUCCESSFUL: ['PAID'],
  PENDING: ['INITIATED', 'HOLD'],
  FAILED: ['REJECTED'],
};

/* ===============================
   Status → MUI Color Mapping
================================ */

export const getSuperadminStatusColor = (
  status: SuperadminInvoiceStatus
): 'success' | 'error' | 'warning' | 'default' => {
  switch (status) {
    case 'PAID':
      return 'success';
    case 'INITIATED':
    case 'HOLD':
      return 'warning';
    case 'REJECTED':
      return 'error';
    default:
      return 'default';
  }
};

/* ===============================
   Status → Display Label
================================ */

export const getSuperadminStatusLabel = (
  status: SuperadminInvoiceStatus
): string => {
  switch (status) {
    case 'PAID':
      return 'Paid';
    case 'INITIATED':
      return 'Initiated';
    case 'HOLD':
      return 'On Hold';
    case 'REJECTED':
      return 'Rejected';
    default:
      return status;
  }
};
